// extracted by mini-css-extract-plugin
export var cursor = "Cursor-module--cursor--Aq4HK";
export var cursorIcon = "Cursor-module--cursorIcon---UJvN";
export var cursorHover = "Cursor-module--cursorHover--1T1AY";
export var cursorClose = "Cursor-module--cursor--close--AfSq3";
export var cursorScroll = "Cursor-module--cursor--scroll--zVpj-";
export var cursorHidden = "Cursor-module--cursor--hidden--geLtM";